import { PropsWithChildren } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { Unit } from 'uom';
import { RadioButton } from 'src/modules/common/components/Radio/RadioButton';

type Props = PropsWithChildren<{
    title: string;
    result: string;
    selectedUnit: Unit.Unit<unknown>;
    allowedUnits: Unit.Unit<unknown>[];
    onUnitChange: (unit: Unit.Unit<unknown>) => void;
}>;

export const CalculatorModalMainSection = ({
    title,
    result,
    selectedUnit,
    allowedUnits,
    onUnitChange,
    children,
}: Props) => (
    <div className="vss-calculator-modal-main-section">
        <div className="vss-calculator-modal-main-section__controls">
            {children}
        </div>

        <div className="vss-calculator-modal-main-section__result">
            <div className="vss-calculator-modal-main-section__result-wrapper">
                <div className="vss-calculator-modal-main-section__title">
                    <I18n messageId={title}/>
                </div>

                <div className="vss-calculator-modal-main-section__value-container">
                    <div className="vss-calculator-modal-main-section__value">
                        {result}
                        &nbsp;
                        <I18n messageId={selectedUnit.name}/>
                    </div>
                </div>
            </div>

            <div className="vss-calculator-modal-main-section__unit">
                {allowedUnits.map((unit) => (
                    <RadioButton
                        key={`${unit.name}`}
                        id={unit.name}
                        required={true}
                        value={unit.name}
                        checked={selectedUnit.name === unit.name}
                        onChange={() => {
                            onUnitChange(unit);
                        }}
                    >
                        <I18n messageId={unit.name}/>
                    </RadioButton>
                ))}
            </div>
        </div>
    </div>
);
